import { useQuery } from '@tanstack/react-query';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { useApiClient } from '../../../hooks';

const useGetAllOrganizationQuestions = (accessToken, organizationId, page = 1, q = '') => {
  const apiClient = useApiClient(accessToken);

  const fetchAllOrganizationQuestions = async () => {
    const params = {
      organizationId,
      page,
      pageSize: 15
    };

    // Only add q parameter if it's not empty
    if (q && q.trim()) {
      params.q = q.trim();
    }

    const { data } = await apiClient.get(`/chat/questions`, {
      params: decamelizeKeys(params)
    });

    return camelizeKeys(data);
  };

  return useQuery(['chat', 'questions', organizationId, page, q], fetchAllOrganizationQuestions, {
    enabled: Boolean(accessToken && organizationId),
    retry: false
  });
};

export { useGetAllOrganizationQuestions };
